import { createAction, props } from '@ngrx/store';

export const loadHods = createAction('[HOD Lookup] Load');

export const loadHodsSuccess = createAction(
  '[HOD Lookup] Load Success',
  props<{ hods: Array<{ id: number; name: string }> }>()
);

export const loadHodsFailure = createAction(
  '[HOD Lookup] Load Failure',
  props<{ error: string }>()
);
